import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export interface InferenceMediaItem {
  alarm_id: string;
  triton_video_url: string;
  tags: string[];
}

export interface InferenceMediaResponse {
  location_alarm_id: string;
  items: InferenceMediaItem[];
}

export interface InferenceMediaParams {
  locationAlarmId?: string;
  rawAlarmIds?: string;
}

/**
 * Fetch inference media for AB testing comparison.
 * Supports two modes:
 * 1. By locationAlarmId - fetches all inference media for a location alarm
 * 2. By rawAlarmIds - fetches inference media for specific raw alarm(s)
 */
export function useInferenceMedia(
  params: InferenceMediaParams | string,
  enabled = true
) {
  // Support legacy string parameter (locationAlarmId only)
  const normalizedParams: InferenceMediaParams =
    typeof params === 'string' ? { locationAlarmId: params } : params;

  const searchParams = new URLSearchParams();
  if (normalizedParams.locationAlarmId) {
    searchParams.set('locationAlarmId', normalizedParams.locationAlarmId);
  }
  if (normalizedParams.rawAlarmIds) {
    searchParams.set('rawAlarmIds', normalizedParams.rawAlarmIds);
  }

  const url = `/v2/orm/ab/inference-media?${searchParams.toString()}`;
  const request = new Request(url);

  // Create a stable query key
  const queryKey = [
    'inferenceMedia',
    normalizedParams.locationAlarmId || '',
    normalizedParams.rawAlarmIds || '',
  ];

  return useAuthenticatedRequest<InferenceMediaResponse>(request, {
    queryKey,
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
    enabled,
  });
}

export default useInferenceMedia;
